import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgUser = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 2C13.7614 2 16 4.23858 16 7C16 8.63573 15.2145 10.088 14.0002 11.0002C15.2145 11.912 16 13.3643 16 15V19H14V15C14 13.3431 12.6569 12 11 12C9.34315 12 8 13.3431 8 15V19H6V15C6 13.3643 6.78547 11.912 7.99981 10.9998C6.78547 10.088 6 8.63573 6 7C6 4.23858 8.23858 2 11 2ZM11 4C9.34315 4 8 5.34315 8 7C8 8.65685 9.34315 10 11 10C12.6569 10 14 8.65685 14 7C14 5.34315 12.6569 4 11 4Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgUser);

export default ForwardRef;
